import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../common/Layout";
import Back from "../common/back/Back";

const LocalSeoGuide = () => {
  // Breadcrumb Schema
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.welsheducation.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Best Study Abroad Consultant in Punjab",
        "item": "https://www.welsheducation.com/study-abroad-consultant-punjab"
      }
    ]
  };

  // Local Business Schema
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    "name": "Welsh Education",
    "description": "The best study abroad consultant in Bathinda, Punjab, providing expert visa assistance and university admission counseling for the UK, USA, Canada, and Australia.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Bathinda",
      "addressRegion": "Punjab",
      "addressCountry": "India"
    },
    "telephone": "+91-9115400982",
    "url": "https://www.welsheducation.com"
  };

  return (
    <>
      <Helmet>
        <title>Best Study Abroad Consultant in Bathinda, Punjab | Welsh Education</title>
        <meta name="description" content="Looking for the best study abroad consultant in Bathinda, Punjab? Welsh Education offers 100% transparent visa assistance and career counseling for Canada, UK, and USA." />
        <meta name="keywords" content="study abroad consultant in Punjab, visa consultant in Bathinda, study in Canada from Punjab, study in UK consultant Punjab, best immigration consultant Bathinda" />
        <link rel="canonical" href="https://www.welsheducation.com/study-abroad-consultant-punjab" />
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(localBusinessSchema)}
        </script>
      </Helmet>

      <Layout>
        <Back title="Your Local Experts in Punjab" />
        
        <section className="seo-article-container" style={{ padding: '60px 20px', maxWidth: '900px', margin: '0 auto', color: '#e5e7eb', lineHeight: '1.8' }}>
          
          <h1 style={{ fontSize: '2.5rem', fontWeight: '800', marginBottom: '30px', color: '#fff', background: 'linear-gradient(90deg, #ff007f, #00ffff)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            The Premier Study Abroad Consultant in Bathinda, Punjab
          </h1>

          <p style={{ fontSize: '1.1rem', marginBottom: '20px' }}>
            If you are a student in Punjab dreaming of pursuing higher education in top-tier international universities, finding the right guidance is your very first step. Located in the heart of Bathinda, <strong>Welsh Education</strong> has established itself as the <strong>best study abroad consultant in Punjab</strong>, offering unparalleled visa success rates, transparent processing, and dedicated career counseling.
          </p>

          <h2 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '20px', color: '#06b6d4' }}>
            Why Students in Punjab Trust Welsh Education
          </h2>
          
          <p style={{ marginBottom: '20px' }}>
            The overseas education market in Punjab is crowded, but Welsh Education stands out through our commitment to student success. We do not believe in a "one-size-fits-all" approach. Whether you are aiming for a Master's degree in the USA or a specialized diploma in Canada, our Bathinda-based experts craft a tailored strategy just for you.
          </p>

          <ul style={{ listStyleType: 'disc', paddingLeft: '20px', marginBottom: '40px' }}>
            <li style={{ marginBottom: '10px' }}><strong>Local Presence, Global Reach:</strong> Based right here in Bathinda, you can visit our office for face-to-face consultations, completely eliminating the anxiety of dealing with remote, faceless agencies.</li>
            <li style={{ marginBottom: '10px' }}><strong>Specialized Expertise for Punjab Applicants:</strong> We understand the specific academic and financial backgrounds of students from Punjab and tailor our visa documentation strategies to ensure maximum approval rates.</li>
            <li style={{ marginBottom: '10px' }}><strong>Comprehensive Test Prep in Bathinda:</strong> We offer localized, intensive coaching for IELTS, PTE, and TOEFL, ensuring you meet the stringent language requirements of global universities.</li>
          </ul>

          <h2 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '20px', color: '#a855f7' }}>
            Our Core Services for International Students
          </h2>

          <h3 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', color: '#fff' }}>Study in Canada from Punjab</h3>
          <p style={{ marginBottom: '20px' }}>
            Canada remains the top choice for students in Punjab due to its welcoming immigration policies and high quality of life. As the leading visa consultant in Bathinda, we guide you through SDS (Student Direct Stream) and non-SDS applications, ensuring your GIC and financial documents are flawless.
          </p>

          <h3 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px', color: '#fff' }}>Study in the UK from Punjab</h3>
          <p style={{ marginBottom: '40px' }}>
            With the Graduate Route visa, the UK has seen a massive surge in interest. We assist students from Bathinda and surrounding regions in securing offers from prestigious UK institutions, focusing heavily on proper CAS (Confirmation of Acceptance for Studies) issuance and Tier 4 visa processing.
          </p>

          <h2 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '20px', color: '#06b6d4' }}>
            Visit Our Office in Bathinda Today
          </h2>

          <p style={{ marginBottom: '30px' }}>
            Your global journey begins locally. Do not risk your future with inexperienced agencies. Connect with Welsh Education, the most trusted <strong>study abroad consultant in Punjab</strong>.
          </p>

          <div style={{ background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '12px', marginBottom: '40px' }}>
            <h4 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#fff', marginBottom: '10px' }}>Contact Information</h4>
            <p style={{ marginBottom: '5px' }}><strong>Location:</strong> Bathinda, Punjab, India</p>
            <p style={{ marginBottom: '5px' }}><strong>Phone:</strong> +91 91154 00982</p>
            <p style={{ marginBottom: '5px' }}><strong>Email:</strong> info@welsheducation.com</p>
          </div>

          <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <a href="/contact" style={{ display: 'inline-block', padding: '15px 40px', background: 'linear-gradient(90deg, #ff007f, #00ffff)', color: '#fff', fontSize: '1.2rem', fontWeight: '700', borderRadius: '50px', textDecoration: 'none', boxShadow: '0 10px 30px rgba(255, 0, 127, 0.4)' }}>
              Schedule Your Free Consultation in Bathinda
            </a>
          </div>

        </section>
      </Layout>
    </>
  );
};

export default LocalSeoGuide;
